import { type FC, useEffect } from 'react';
import { useNavigate } from 'react-router';

interface Props {
  to: string;
}

export const Redirect: FC<Props> = (props) => {
  const { to } = props;

  const navigate = useNavigate();

  useEffect(() => {
    navigate(to);
  }, [navigate, to]);

  return null;
};
